<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-6">
                <h4 class="card-title">Estudos DICOM</h4>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">
                  <router-link to="/dicom/upload" class="btn btn-success">
                    <i class="bx bx-upload me-1"></i> Upload DICOM
                  </router-link>
                </div>
              </div>
            </div>

            <div v-if="loading" class="text-center">
              <div class="spinner-border" role="status">
              </div>
            </div>

            <div v-else class="table-responsive">
              <table class="table table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Study ID</th>
                    <th scope="col">Paciente</th>
                    <th scope="col">Modalidade</th>
                    <th scope="col">Data do Estudo</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Número de Séries</th>
                    <th scope="col">Status</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="study in studies" :key="study.id">
                    <td>{{ study.study_id }}</td>
                    <td>{{ study.patient_name || 'N/A' }}</td>
                    <td>
                      <span class="badge bg-primary">
                        {{ study.modality || 'N/A' }}
                      </span>
                    </td>
                    <td>{{ formatDate(study.study_date) }}</td>
                    <td>{{ study.study_description || 'N/A' }}</td>
                    <td>{{ study.series_count || 0 }}</td>
                    <td>
                      <span class="badge bg-success">Disponível</span>
                    </td>
                    <td>
                      <div class="d-flex gap-2">
                        <button 
                          class="btn btn-outline-primary btn-sm"
                          @click="viewStudy(study)"
                          title="Visualizar"
                        >
                          <i class="bx bx-show"></i>
                        </button>
                        <button 
                          class="btn btn-outline-info btn-sm"
                          @click="downloadStudy(study)"
                          title="Download"
                        >
                          <i class="bx bx-download"></i>
                        </button>
                        <button 
                          class="btn btn-outline-danger btn-sm"
                          @click="deleteStudy(study)"
                          title="Excluir"
                        >
                          <i class="bx bx-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="studies.length === 0">
                    <td colspan="8" class="text-center">Nenhum estudo DICOM encontrado</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { dicomService } from "@/api/dicom";

export default {
  page: {
    title: "Estudos DICOM",
    meta: [{ name: "description", content: "Gerenciar estudos DICOM" }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Estudos DICOM",
      items: [
        {
          text: "DICOM",
          href: "/dicom",
        },
        {
          text: "Estudos",
          active: true,
        },
      ],
      studies: [],
      loading: false,
    };
  },
  async created() {
    await this.loadStudies();
  },
  methods: {
    async loadStudies() {
      this.loading = true;
      try {
        const response = await dicomService.listStudies();
        this.studies = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar estudos:", error);
        this.$toast.error("Erro ao carregar estudos DICOM");
      } finally {
        this.loading = false;
      }
    },

    viewStudy(study) {
      this.$router.push(`/dicom/viewer?study_id=${study.study_id}`);
    },

    async downloadStudy(study) {
      try {
        // Implementar download do estudo
        console.log("Baixando estudo:", study.study_id);
        this.$toast.info(`Download do estudo ${study.patient_name} iniciado`);
      } catch (error) {
        console.error("Erro ao baixar estudo:", error);
        this.$toast.error("Erro ao baixar estudo");
      }
    },

    async deleteStudy(study) {
      if (confirm(`Tem certeza que deseja excluir o estudo ${study.study_id}?`)) {
        try {
          await dicomService.deleteStudy(study.study_id);
          this.$toast.success("Estudo excluído com sucesso");
          await this.loadStudies();
        } catch (error) {
          console.error("Erro ao excluir estudo:", error);
          this.$toast.error("Erro ao excluir estudo");
        }
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('pt-BR');
    },
  },
};
</script>
